/**
 * Live data for the right-rail workspace (Notes + To-do).
 *
 * Notes and todos are mapped from the shared domain feed in `FeedContext`.
 */
import { useMemo } from "react";

import { useFeed } from "@/context/FeedContext";
import { useFeedTodos } from "@/hooks/useFeedTodos";
import { mapFeedEventsToNotes } from "@/features/workspace/mapWorkspaceRail";
import type { WorkspaceNote } from "@/types/workspace";

interface WorkspaceRailState {
  notes: WorkspaceNote[];
  todos: ReturnType<typeof useFeedTodos>["todos"];
  loading: boolean;
  error: string | null;
}

export function useWorkspaceRail(): WorkspaceRailState {
  const { events, loading: feedLoading } = useFeed();
  const { todos, loading: todosLoading } = useFeedTodos();

  const notes = useMemo(() => mapFeedEventsToNotes(events), [events]);

  return {
    notes,
    todos,
    loading: feedLoading || todosLoading,
    error: null,
  };
}
